import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const STORAGE_KEY = 'buildiq_theme_preference';

export function ThemeProvider({ children }) {
  const [preference, setPreference] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || 'system';
  });
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const applyTheme = () => {
      let dark = false;
      if (preference === 'dark') {
        dark = true;
      } else if (preference === 'system') {
        dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      }
      setIsDark(dark);
      document.documentElement.classList.toggle('dark', dark);
    };

    applyTheme();

    // Listen for system preference changes
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => { if (preference === 'system') applyTheme(); };
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [preference]);

  const setTheme = (value) => {
    setPreference(value);
    localStorage.setItem(STORAGE_KEY, value);
  };

  return (
    <ThemeContext.Provider value={{ preference, isDark, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
